<template>
  <div id="dashboard">
    <header-vue></header-vue>
    <!-- include="DashContent" -->
    <keep-alive :exclude="['TokenUsage']">
      <router-view v-if="showView"></router-view>
    </keep-alive>
  </div>
</template>

<script>
import HeaderVue from '../components/DashBoard/Header.vue'
import Helper from '../common/helper'
import { mapState } from 'vuex'
// import DashContent from '../components/DashBoard/Content.vue'
export default {
  components: {
    HeaderVue
    // DashContent
  },
  data () {
    return {
      showView: false,
      env: Helper.getEnv(),
      clientSecret: ''
    }
  },
  mounted () {

  },
  created () {
    if (this.permissionLoad) {
      this.handleShowView(this.$route.name)
    } else {
      this.$store.dispatch('billingInternalPermission').then(() => {
        this.handleShowView(this.$route.name)
      })
    }
  },
  methods: {
    testclientSecret () {
      if (!this.clientSecret) return
      const clientSecret = this.clientSecret
      this.$payment.open(clientSecret, (type) => {
        console.log('type', type)
      })
    },
    handleShowView (value) {
      const permissionList = ['WhiteList', 'SKU', 'GoWhitelist', 'Subscriptions', 'TokenCheckGroups']
      if (this.accessBillingInternal) {
        this.showView = true
      } else if (value.includes('TokenUsage')) {
        this.showView = !this.env.includes('prod')
      } else if (permissionList.some(item => value.includes(item))) {
        this.showView = false
      } else {
        this.showView = true
      }
    }
  },
  computed: {
    ...mapState({
      accessBillingInternal: 'accessBillingInternal',
      permissionLoad: 'permissionLoad'
    })
  },
  watch: {
    '$route.name' (value) {
      console.log('$route.name', value)
      this.handleShowView(value)
    }
  }
}
</script>

<style>
#dashboard {
  width: 100%;
  height: 100vh;
}
</style>
